export const orangeDark = "#FF6D00";
export const orangeLight = "#f77a1a";
export const orangeLighter = "#faa666";
export const orange200 = "#F9DBAF";
export const darkblue = "#0A0D14";
export const gray03 = "#AAAAAA";
export const gray25 = "#FCFCFD";
export const gray50 = "#F9FAFB";
export const gray100 = "#F2F4F7";
export const gray200 = "#EAECF0";
export const gray300 = "#D0D5DD";
export const gray400 = "#98A2B3";
export const gray600 = "#475467";
export const gray700 = "#344054";
export const gray800 = "#1D2939";
export const gray850 = "#302F2F";
export const gray900 = "#0A0D14";
export const darkBase = "#242425";

export const baseG200 = "#CACACA";
export const baseG400 = "#818181";
export const yellow100 = "#FEF7C3";
export const green100 = "#D1FADF";
export const green200 = "#A6F4C5";
export const successDark = "#282C29";
export const warningDark = "#34322E";

/* 
The `Colors` type is an object type where each property is a string. This type is used to define a color palette for a design system. Each property represents a color in the design system and its value is expected to be a string, which will typically be a hexadecimal color code.

The `DESIGN_SYSTEM_COLORS` constant is an object that implements the `Colors` type. This object provides specific color codes for each color in the design system. The colors are divided into several categories such as primary colors, notebook colors, and secondary colors. Each category has a range of colors, from light to dark, represented by increasing numbers (e.g., `gray25` is lighter than `gray50`).

For example, `baseWhite` is defined as `#FFFFFF`, which is the hexadecimal code for white. Similarly, `primary25` is defined as `#FFF2EA`, which could be a very light shade of the primary color in the design system.

This color palette can be used throughout a project to maintain consistency in the UI design. By referring to colors by their property names, it's easier to manage and update the color scheme of the project. For instance, if you want to change the color `primary500`, you only need to update it in `DESIGN_SYSTEM_COLORS`, and the change will be reflected everywhere `primary500` is used. */

export const DESIGN_SYSTEM_COLORS = {
  // ------------------------- primary colors
  // base
  baseWhite: "#FFFFFF",
  baseBlack: "#121212",
  baseGraphit: "#242425",

  // gray
  gray25: "#FCFCFD",
  gray50: "#F9FAFB",
  gray100: "#F2F4F7",
  gray200: "#EAECF0",
  gray250: "#E1E4E9",
  gray300: "#D0D5DD",
  gray400: "#98A2B3",
  gray500: "#667085",
  gray600: "#475467",
  gray700: "#344054",
  gray800: "#1D2939",
  gray850: "#302F2F",
  gray900: "#0A0D14",

  // primary
  primary25: "#FFF2EA",
  primary50: "#FFE2D0",
  primary100: "#FFD2B6",
  primary200: "#FFC29C",
  primary300: "#FFB282",
  primary400: "#FFA168",
  primary500: "#FF914E",
  primary600: "#FF8134",
  primary700: "#FF711A",
  primary800: "#FF6D00",
  primary900: "#E56200",

  // success
  success25: "#F6FEF9",
  success50: "#ECFDF3",
  success100: "#D1FADF",
  success200: "#A6F4C5",
  success300: "#6CE9A6",
  success400: "#32D583",
  success500: "#12B76A",
  success600: "#039855",
  success700: "#027A48",
  success800: "#05603A",
  success900: "#054F31",
  success1000: "#282C29",

  // ------------------------- notebooks colors
  // base
  notebookBl1: "#E9E9E9",
  notebookBd1: "#28282A",
  notebookMainBlack: "#1B1A1A",

  // gray
  notebookG50: "#ECECEC",
  notebookG75: "#E2E2E2",
  notebookG100: "#CACACA",
  notebookG200: "#A4A4A4",
  notebookG300: "#818181",
  notebookG400: "#575757",
  notebookG450: "#4E4D4D",
  notebookG500: "#404040",
  notebookG600: "#2F2F2F",
  notebookG700: "#242425",
  notebookG800: "#303134",
  notebookG900: "#1F1F1F",

  // secondary
  notebookO100: "#F8A824",
  notebookO200: "#E77240",
  notebookO800: "#85603B",
  notebookO900: "#55402B",
  notebookPink: "#FD7373",
  notebookScarlet: "#E34848",
  notebookRed: "#C03938",
  notebookRed2: "#D92D20",
  notebookRed3: "#301A1A",

  // ------------------------- secondary colors
  // blue
  blue25: "#F5FAFF",
  blue50: "#EFF8FF",
  blue100: "#D1E9FF",
  blue200: "#B2DDFF",
  blue300: "#84CAFF",
  blue400: "#53B1FD",
  blue500: "#2E90FA",
  blue600: "#1570EF",
  blue700: "#175CD3",
  blue800: "#1849A9",
  blue900: "#194185",

  // indigo
  indigo25: "#F5F8FF",
  indigo50: "#EEF4FF",
  indigo100: "#E0EAFF",
  indigo200: "#C7D7FE",
  indigo300: "#A4BCFD",
  indigo400: "#8098F9",
  indigo500: "#6172F3",
  indigo600: "#444CE7",
  indigo700: "#3538CD",
  indigo800: "#2D31A6",
  indigo900: "#2D3282",

  // teal
  teal25: "#F6FEFC",
  teal50: "#F0FDF9",
  teal100: "#CCFBEF",
  teal200: "#99F6E0",
  teal300: "#5FE9D0",
  teal400: "#2ED3B7",
  teal500: "#15B79E",
  teal600: "#0E9384",
  teal700: "#107569",
  teal800: "#125D56",
  teal900: "#134E48",

  // blueLigth
  blueLight25: "#F5FBFF",
  blueLight50: "#F0F9FF",
  blueLight100: "#E0F2FE",
  blueLight200: "#B9E6FE",
  blueLight300: "#7CD4FD",
  blueLight400: "#36BFFA",
  blueLight500: "#0BA5EC",
  blueLight600: "#0086C9",
  blueLight700: "#026AA2",
  blueLight800: "#065986",
  blueLight900: "#0B4A6F",

  // orange
  orange25: "#FEFAF5",
  orange50: "#FEF6EE",
  orange100: "#FDEAD7",
  orange200: "#F9DBAF",
  orange250: "#DCA882",
  orange300: "#F7B27A",
  orange400: "#F38744",
  orange500: "#EF6820",
  orange600: "#E04F16",
  orange700: "#B93815",
  orange800: "#932F19",
  orange900: "#772917",

  // yellow
  yellow25: "#FEFDF0",
  yellow50: "#FEFBE8",
  yellow100: "#FEF7C3",
  yellow200: "#FEEE95",
  yellow300: "#FDE272",
  yellow400: "#FAC515",
  yellow500: "#EAAA08",
  yellow600: "#CA8504",
  yellow700: "#A15C07",
  yellow800: "#854A0E",
  yellow900: "#713B12",
  yellow1000: "#34322E"
};
